import $ from 'jquery';

import 'sylius/ui/sylius-auto-complete';

import 'sylius/admin/sylius-product-images-preview';

import './add-to-cart-direct';
import './broker-photos-collection';
import './svg-config-edit';
import './svg-config-view';
import './gtag';

import svgConfigViewExport from './svg-config-view-export';

$(document).ready(() => {
  var open = false;
  $('.ui.modal.corona').modal('show');
  $('.trigger').on('click', function(){
    if(open){
      $('.menu-static').removeClass('open');
    $('.trigger').removeClass('trigger-open');
      open = false;
    }else{
      $('.menu-static').addClass('open');
    $('.trigger').addClass('trigger-open');
      open = true;
    }

  });
  // https://github.com/Sylius/Sylius/pull/9627
  $('.ui.cards.guarantees > .card .image').dimmer('hide').dimmer('destroy');
  $('.ui.cards.brands > .card .image').dimmer('hide').dimmer('destroy');
  $('.ui.cards.taxons > .card .image').dimmer('hide').dimmer('destroy');
  $('.ui.cards.products > .card .image').dimmer('hide').dimmer('destroy');

  $('.ui.cards.products > .card').dimmer({
    on: 'hover',
  });

  $('.ui.cards.products').addToCartDirect();

  $('img[data-svg-url]').svgConfigView();

  $('img[data-svg-personalized=true]').parent().addClass('svg-modified');

  $('.ui.cards.products').on('click', '.button.modify', (evt) => {
    const $img = $(evt.currentTarget).closest('.product').find('img[data-svg-url]');

    $img.svgConfigEdit();
  });
  $('.ui.grid.product-details .button.modify').on('click', () => {
    const $img = $('#main-image');

    $img.svgConfigEdit();
  });
  $('.checkout-container .validate-templates').on('click', '.button.modify:not(.disabled)', (evt) => {
    const $templateContainer = $(evt.currentTarget).closest('.template');
    const $img = $templateContainer.find('img[data-svg-url]');

    $img.svgConfigEdit();
  });
  $('.checkout-container .validate-templates').on('click', '.button.validate:not(.disabled)', (evt) => {
    evt.preventDefault();

    const $validateButton = $(evt.currentTarget);
    const $modifyButton = $validateButton.siblings('.button.modify');
    const $templateContainer = $validateButton.closest('.template');
    const $img = $templateContainer.find('img[data-svg-url]');

    $modifyButton.addClass('disabled');
    $validateButton.addClass('disabled loading');

    svgConfigViewExport({
      svgUrl: $img.data('svgUrl'),
      svgPersonalized: $img.data('svgPersonalized'),
    })
      .then((svgString) => {
        const data = new FormData();
        data.set('svg_file', new Blob([svgString], { type: 'image/svg+xml' }), 'template.svg');

        return fetch($validateButton.data('svgSaveUrl'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: data,
          credentials: 'same-origin',
        })
          .then(response => response.json());
      })
      .then(() => {
        const $validatedCheckbox = $templateContainer.find('input[type="checkbox"][name$="[validated]"]');

        $validatedCheckbox.prop('checked', true);
        $validateButton.addClass('positive');
        $validateButton.removeClass('loading');
        $validateButton.html($validateButton.data('validatedHtml'));
      });
  });

  $('.sylius-autocomplete').autoComplete();

  $('.broker-photos[data-form-type="collection"]').brokerPhotosCollection();

  $(document).previewUploadedImage('.broker-photos[data-form-type="collection"]');

  const $agencyInput = $('#app_broker_profile_agency');
  const $changeAgencyButton = $('#sylius-broker-change-agency');

  $agencyInput.closest('.field').addClass('disabled');
  $changeAgencyButton.removeClass('hidden element');

  $changeAgencyButton.on('click', () => {
    // https://github.com/Sylius/Sylius/issues/9438
    // https://github.com/Sylius/Sylius/pull/9627
    $changeAgencyButton.closest('form').removeClass('loading');

    $agencyInput.closest('.field').removeClass('disabled');
    $changeAgencyButton.hide();
  });

  $('.sylius-autocomplete-remove').on('click', (evt) => {
    const $removeButton = $(evt.currentTarget);

    // https://github.com/Sylius/Sylius/issues/9438
    // https://github.com/Sylius/Sylius/pull/9627
    $removeButton.closest('form').removeClass('loading');

    const $dropdown = $removeButton.closest('.ui.input').find('.sylius-autocomplete');

    $dropdown.dropdown('clear selection');
  });

  $('.ui.menu.photocut .item').tab();

  $('.modal-opener').on('click', (evt) => {
    $('#confirmation-modal').remove()
    $('.ui.modal')
      .modal({
        inverted: true
      })
      .modal('show').css('text-align', 'center')
    ;
  })

  $('#landing-register-form').submit(function(e) {
    e.preventDefault();
    $('#form-btn').prop('disabled', true).text('Sending...')
    var form = $(this);
    var actionUrl = form.attr('action');
    $.ajax({
      type: 'POST',
      url: actionUrl,
      data: form.serialize(),
    })
    .done(function() {
      $('#form-btn').text('Sent...')
      $('#form-info').text('Message sent...We will contact you.');
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'generate_lead',
            'lead_type': 'landing page form',
            'lead_step': 'success'
          }
        });
    })
    .fail(function() {
      $('#form-info').text('Error occurred...Pls, try later');
    });
  });

});
